export const GlobalVars = {
  "water_freq_vars": 
    [
      "Daily",
      "Twice per week",
      "Weekly",
      "Every 2 weeks",
      "Monthly",
      "Every 6 Weeks",
    ],
    "water_freq_default": "Weekly",

  "water_qty_vars": 
    [
      "Mist",
      "Damp but not wet",
      "Normal",
      "Soak"
    ],
    "water_qty_default": "Normal",


  "light_level_vars": 
    [
      "Direct bright all day",
      "Direct bright morning",
      "Direct bright afternoon",
      
      "Direct low all day",
      "Direct low morning",
      "Direct low afternoon",

      "Indirect bright all day",
      "Indirect bright morning",
      "Indirect bright afternoon",
      
      "Indirect low all day",
      "Indirect low morning",
      "Indirect low afternoon",

      "Lamp / Grow Light",
      "Any",
    ],
    "light_level_default": "",

  "temp_vars":
    [
      "High ( >75 F)",
      "Normal (55-75 F)",
      "Low (< 55 F)"
    ],
    "temp_default": "Normal (55-75 F)",

  "humidity_vars":
    [
      "High",
      "Medium",
      "Low"
    ],
    "humidity_default": "Medium",

    "fertilizer_type_vars":
    [
      "None",
      "Balanced",
      "Nitrogen",
      "Phosphorus",
      "calcium",
      "Micro-nutrient",
      "Unknown",
    ],
    "fertilizer_type_default": "Balanced",

    "fertilizer_freq_vars":
    [
      "Unknown",
      "Every watering",
      "Every other watering",
      "Once per month",
      "Once every 2 months",
      "Twice per year",
      "Once per year",
    ],
    "fertilizer_freq_default": "Unknown",
}

export default GlobalVars;